const mockPricingData = {
  summary: {
    averagePremium: "+13%",
    premiumText: "Premium for WEB 17 over Artisse",
    web17Range: "€8,000 - €11,470",
    artisseRange: "€7,000 - €10,300",
    marketsTracked: "3 European Regions"
  },
  regions: [
    {
      id: "drg_baseline",
      name: "DRG / Baseline Markets",
      examples: "Germany, Switzerland",
      our_product: {
        min: 11470,
        max: 11600,
        label: "€11,470 - €11,600",
      },
      competitor_product: {
        min: 9700,
        max: 10300,
        label: "€9,700 – €10,300",
      }
    },
    {
      id: "centrally_tendered",
      name: "Centrally Tendered Markets",
      examples: "United Kingdom NHS",
      our_product: {
        min: 8200,
        max: 10000,
        label: "€8,200 – €10,000",
      },
      competitor_product: {
        min: 7000,
        max: 8500,
        label: "€7,000 – €8,500",
      }
    },
    {
      id: "strictly_capped",
      name: "Strictly Capped / Regional Markets",
      examples: "France, Italy, Spain",
      our_product: {
        min: 8000,
        max: 8500,
        label: "€8,000 – €8,500",
      },
      competitor_product: {
        min: 7000,
        max: 8300,
        label: "€7,000 – €8,300",
      }
    }
  ]
};

export default mockPricingData;
